import { Button } from 'react-bootstrap'

export default function ApplyButton(props) {

    const { button_name, onClick } = props

    return (
        <>
            <Button
                type='button'
                size='sm'
                className='apply_btn'
                onClick={onClick}
            >
                {button_name}
            </Button>
        </>
    )
}